/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GCPRegionsEnum } from './gCPRegionsEnum';


export interface CreateGcpSecretRequest { 
    region_id: GCPRegionsEnum;
    /**
     * Secret Name/Key
     */
    secret_name: string;
    /**
     * Secret Value
     */
    secret_value: string;
}
export namespace CreateGcpSecretRequest {
}


